import { Navigate } from 'react-router-dom';
import Page404 from '@/common/views/Page404';
import OrganizationsPage from './views/Organizations';
import SkillsPage from './views/Skills';

export const adminRoutes = [
  {
    path: '/admin',
    name: '厂商管理',
    icon: 'crown',
    children: [
      {
        index: true,
        element: <Navigate to="organizations" replace />,
      },
      {
        path: 'organizations',
        name: '租户管理',
        icon: 'appstore',
        element: <OrganizationsPage />,
      },
      {
        path: 'skills',
        name: '技能管理',
        icon: 'tool',
        element: <SkillsPage />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
];
